/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ex_TitleInputs */

const en_csv_to_json_ex_title = /** @type {(inputs: Csv_To_Json_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parsing a quoted export`)
};

const ko_csv_to_json_ex_title = /** @type {(inputs: Csv_To_Json_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인용된 내보내기 파싱하기`)
};

const ja_csv_to_json_ex_title = /** @type {(inputs: Csv_To_Json_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用されたエクスポートをパースする`)
};

/**
* | output |
* | --- |
* | "Parsing a quoted export" |
*
* @param {Csv_To_Json_Ex_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ex_title = /** @type {((inputs?: Csv_To_Json_Ex_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ex_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ex_title(inputs)
	if (locale === "ko") return ko_csv_to_json_ex_title(inputs)
	return ja_csv_to_json_ex_title(inputs)
});